import React, { FC } from 'react';

import { formatPhoneNumber } from '../utilities/formatting';

import { TextInput, TextInputProps } from './TextInput';

/* PhoneNumberInput */
// wraps a normal TextInput, but formats incoming text to look like a phone number
// Retains format when passing value to form handler

export const PhoneNumberInput: FC<TextInputProps> = ({ ...props }) => {
  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange } = props;
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    e.target.value = formattedPhoneNumber;
    onChange(e);
  };

  return <TextInput {...props} type="tel" onChange={handlePhoneNumberChange} />;
};
